// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j4eB","title":"styles_title__2BIyJ"};